import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IconCircleX, IconRefresh } from "@tabler/icons-react";
import paymentService from "../../services/paymentService";

const REDIRECT_DELAY_MS = 5000;

const REASON_TEXT = {
    cancelled: "আপনি পেমেন্ট বাতিল করেছেন।",
    failed: "পেমেন্ট সম্পন্ন হয়নি।",
};

export default function PaymentFailed() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const reason = searchParams.get("reason") || "failed";
    const orderId = searchParams.get("orderId");
    const transactionId = searchParams.get("transaction_id");
    const gateway = searchParams.get("gateway"); // 'ssl' for SSLCommerz, absent for Moneybag
    // Single unified buy-credit tab — it picks the gateway by region internally.
    const buyTab = "buycredit";

    // Break out of the SSLCommerz popup iframe (if we're inside it) to the top window.
    useEffect(() => {
        if (window.top && window.top !== window.self) {
            try { window.top.location.href = window.location.href; } catch { /* cross-origin: ignore */ }
        }
    }, []);

    useEffect(() => {
        if (orderId) {
            const verify = gateway === "ssl"
                ? paymentService.verifyPaymentSSL(orderId)
                : paymentService.verifyPayment(orderId, transactionId);
            verify.catch(() => {});
        }
    }, [orderId, transactionId, gateway]);

    useEffect(() => {
        const timer = setTimeout(() => navigate("/settings?tab=credits"), REDIRECT_DELAY_MS);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-zinc-50 dark:bg-zinc-950">
            <div className="w-full max-w-md bg-white dark:bg-zinc-900 rounded-xl border border-zinc-200 dark:border-zinc-700 shadow-lg p-8">
                <div className="flex flex-col items-center gap-4 text-center">
                    {/* Error icon */}
                    <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                        <IconCircleX size={48} className="text-red-600 dark:text-red-400" />
                    </div>

                    <h2 className="text-2xl font-bold text-red-600 dark:text-red-400">
                        {reason === "cancelled" ? "পেমেন্ট বাতিল" : "পেমেন্ট ব্যর্থ"}
                    </h2>

                    <p className="text-base text-zinc-500 dark:text-zinc-400">
                        {REASON_TEXT[reason] || REASON_TEXT.failed} আপনি আবার চেষ্টা করতে পারেন।
                    </p>

                    <p className="text-xs text-zinc-400 dark:text-zinc-500">
                        {Math.ceil(REDIRECT_DELAY_MS / 1000)} সেকেন্ডে রিডাইরেক্ট হবে...
                    </p>

                    <button
                        onClick={() => navigate(`/settings?tab=${buyTab}`)}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                    >
                        <IconRefresh size={16} />
                        আবার চেষ্টা করুন
                    </button>
                </div>
            </div>
        </div>
    );
}
